export const path = '';

export default path;
